import { render } from "./SidebarMenuItem.vue?vue&type=template&id=5ac7822a&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=5ac7822a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac7822a"]])

export default __exports__